import React from 'react';
import { useParams } from 'react-router-dom';

import { Text, Box, Title, Divider, Anchor } from '@mantine/core';

const UrgentIssue = () => {
  return (
    <Box>
      <Title order={1}>Urgent Issue</Title>
      <Divider my="lg" />
      <Text>
        For any urgent issues, please contact the IT Service Desk at:{' '}
        <Anchor color="blue" href="tel:905-576-8711p34357">
          905-576-8711 (34357)
        </Anchor>
      </Text>
    </Box>
  );
};

export default UrgentIssue;
